import { createContext, useContext } from 'react';
import { UserContext } from '@/modules/auth/models/User';
import { UserRole } from '@/modules/auth/models/UserRole';

interface User {
  id: string;
  organizationId: string;
  retailerId: string;
  storeId: string;
  supplierId: string;
}

interface AuthorizationContextType {
  isLoggedIn: boolean;
  accessToken: string | undefined;
  idToken: string | undefined;
  role?: UserRole;
  roles: UserRole[];
  currentUser: () => Partial<User>;
  changeRole: (role: UserRole) => Promise<void>;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => Promise<void>;
  switchContext: (userContext: UserContext) => Promise<boolean>;
}

const AuthContext = createContext<AuthorizationContextType>({
  isLoggedIn: false,
  accessToken: undefined,
  idToken: undefined,
  role: undefined,
  roles: [],
  currentUser: () => ({}),
  changeRole: async () => {},
  login: async () => false,
  logout: async () => {},
  switchContext: async () => false,
});

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
